export enum ChessClass {
  King = 'KING',
  Knight = 'KNIGHT',
  Rook = 'ROOK',
  Bishop = 'BISHOP',
}

export enum ChessSlot {
  KING = 'KING',
  KNIGHT = 'KNIGHT',
  ROOK = 'ROOK',
  BISHOP_1 = 'BISHOP_1',
  BISHOP_2 = 'BISHOP_2',
  UNUSED = 'UNUSED'
}

export type ChessType = {
  name: string;
  id: number;
  img: string;
  chessType: ChessClass;
  maxHp: number;
  curHp: number;
  atk: number;
  def: number;
  spd: number;
  skill: string;
  slot: ChessSlot;
  price: number;
  saleListed: boolean;
  nftId: string;
  playerId: number;
};

export type ChessResponse = {
  chess_id: string;
  type: ChessClass;
  max_hp: number;
  hp: number;
  atk: number;
  def: number;
  spd: number;
  position: string;
  timestamp: string;
  slot: ChessSlot;
  price: number,
  saleListed: boolean
  nftId: string;
  playerId: number;
};
